

import Vue from 'vue'
import App from './App'
import router from './router'
import XHeader from 'vux/src/components/x-header/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import HttpUtils from '@/js/httpUtils'
import Url from '@/js/url'
import RequestParam from '@/js/RequestParam'
import cache from '@/js/cache'
import VueWechatTitle from 'vue-wechat-title'
import { PaletteButton, Loadmore, Tabbar, TabItem, TabContainer, TabContainerItem, InfiniteScroll } from 'mint-ui'
import 'mint-ui/lib/style.css'
import '@/assets/css/mintui.css'

Vue.config.productionTip = false

window.RequestParam = RequestParam
window.$cache = cache
Vue.prototype.$http = HttpUtils
Vue.prototype.$urlPath = Url

Vue.component(PaletteButton.name, PaletteButton)
Vue.component(Loadmore.name, Loadmore)
Vue.component(Tabbar.name, Tabbar)
Vue.component(TabItem.name, TabItem)
Vue.component(TabContainer.name, TabContainer)
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.use(InfiniteScroll)
Vue.component('x-header', XHeader)
Vue.component('view-box', ViewBox)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(VueWechatTitle)

const whiteList = [
'/',
'/wxAuth'
] // 不重定向白名单
router.beforeEach((to, from, next) => {
console.log('mainTo', to)
let user = window.$cache.get('user')
if (user) {
next()
} else {
let toFullPath = encodeURIComponent(to.fullPath)
if (whiteList.indexOf(to.path) !== -1) {
next()
} else if (to.path.indexOf('/waiter/') === 0) {
next(`/waiter/login?to=${toFullPath}`)
} else if (to.path.indexOf('/entertainers/') === 0) {
next(`/entertainers/login?to=${toFullPath}`)
} else {
next(`/?to=${toFullPath}`) 
}
}
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js